export default __webpack_public_path__ + "static/media/38-HeightOfSummer.c38413f5.jpeg";